// order is important!
export enum Feature {
  PayPerLead = "pay_per_lead",
  NicheFiles = "niche_files",
  Tickets = "tickets",
  FlikID = "flik_id",
  MarketMap = "market_map",
  BackTestingAI = "back_testing_ai",
  ReiSift = "rei_sift",
}
